import { Directive, Input, Pipe, NgModule } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { isValidIBAN, electronicFormatIBAN, friendlyFormatIBAN } from 'ibantools';

import * as ɵngcc0 from '@angular/core';
function ibanValidator(countryCode) {
    return (control) => {
        if (countryCode && control.value) {
            return /^[A-Z]{2}$/i.test(countryCode) &&
                new RegExp(`^${countryCode}.*$`, "i").test(control.value) &&
                isValidIBAN(electronicFormatIBAN(control.value))
                ? null
                : { iban: { value: control.value } };
        }
        else if (control.value) {
            return isValidIBAN(electronicFormatIBAN(control.value))
                ? null
                : { iban: { value: control.value } };
        }
        return null;
    };
}
class IbanDirective {
    validate(control) {
        return ibanValidator(this.countryCode)(control);
    }
    registerOnValidatorChange(fn) {
        this._onChange = fn;
    }
    ngOnChanges(changes) {
        if ("countryCode" in changes && this._onChange) {
            this._onChange();
        }
    }
}
IbanDirective.ɵfac = function IbanDirective_Factory(t) { return new (t || IbanDirective)(); };
IbanDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: IbanDirective, selectors: [["", "ngxIban", ""]], inputs: { countryCode: ["ngxIban", "countryCode"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: IbanDirective, multi: true }
        ]), ɵngcc0.ɵɵNgOnChangesFeature] });
IbanDirective.propDecorators = {
    countryCode: [{ type: Input, args: ["ngxIban",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IbanDirective, [{
        type: Directive,
        args: [{
                selector: "[ngxIban]",
                providers: [
                    { provide: NG_VALIDATORS, useExisting: IbanDirective, multi: true }
                ]
            }]
    }], null, { countryCode: [{
            type: Input,
            args: ["ngxIban"]
        }] }); })();

class IbanPipe {
    transform(value, separator) {
        return value ? friendlyFormatIBAN(value, separator) : null;
    }
}
IbanPipe.ɵfac = function IbanPipe_Factory(t) { return new (t || IbanPipe)(); };
IbanPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "iban", type: IbanPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IbanPipe, [{
        type: Pipe,
        args: [{
                name: "iban"
            }]
    }], null, null); })();

class NgxIbanModule {
}
NgxIbanModule.ɵfac = function NgxIbanModule_Factory(t) { return new (t || NgxIbanModule)(); };
NgxIbanModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxIbanModule });
NgxIbanModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxIbanModule, { declarations: [IbanDirective, IbanPipe], exports: [IbanDirective, IbanPipe] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxIbanModule, [{
        type: NgModule,
        args: [{
                declarations: [IbanDirective, IbanPipe],
                imports: [],
                exports: [IbanDirective, IbanPipe]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-iban
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IbanDirective, IbanPipe, NgxIbanModule, ibanValidator };

//# sourceMappingURL=ngx-iban.js.map